(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function start(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var end = new Date((el.dataset.countdown || '').trim().replace(' ', 'T'));
    if (isNaN(end.getTime())) { el.hidden = true; return; }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var set = function (k, v) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = pad(v); };
    var timer;
    function tick() {
      var diff = Math.floor((end.getTime() - Date.now()) / 1000);
      if (diff <= 0) { el.classList.add('is-ended'); clearInterval(timer); return; }
      set('d', Math.floor(diff / 86400));
      set('h', Math.floor(diff % 86400 / 3600));
      set('m', Math.floor(diff % 3600 / 60));
      set('s', diff % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  }
  function init() { document.querySelectorAll('[data-countdown]').forEach(start); }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
